import { render, staticRenderFns } from "./TinyMCEEditor.vue?vue&type=template&id=ec0c8846&scoped=true"
import script from "./TinyMCEEditor.vue?vue&type=script&lang=js"
export * from "./TinyMCEEditor.vue?vue&type=script&lang=js"
import style0 from "./TinyMCEEditor.vue?vue&type=style&index=0&id=ec0c8846&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0c8846",
  null
  
)

export default component.exports